import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import _ from 'lodash'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#03B0EE',
      contrastText: '#FFF',
    },
  },
  typography: { useNextVariants: true },
})

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
}

export default props => {
  const {
    id,
    label,
    value = '',
    options,
    onChange,
  } = props

  const valueAux = !value.length ? [] : value.split(',')

  return (
    <ThemeProvider theme={theme}>
      <FormControl style={{ width: '100%' }}>
        <InputLabel htmlFor={id}>
          {label}
        </InputLabel>
        <Select
          multiple
          value={valueAux}
          input={<Input id={id} />}
          renderValue={selected => selected.join(', ')}
          MenuProps={MenuProps}
          onChange={event => {
            const diff = _.head(_.difference(event.target.value, valueAux))
            const option = _.find(options, { value: diff }) || {}

            onChange(event, {
              ...option,
              value: event.target.value.join(','),
            })
          }}
        >
          {options.map((option, index) => (
            <MenuItem
              key={index}
              value={option.value}
            >
              <Checkbox checked={value.includes(option.value)} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  )
}
